import { createFileRoute } from "@tanstack/react-router";
import { UsersTable } from "@/components/admin/users-table";
import { usePageTitle } from "@/hooks/use-page-title";
import { adminUsersQueryOptions } from "@/lib/api/admin";

export const Route = createFileRoute("/dashboard/admin/users/")({
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(adminUsersQueryOptions({})),
  component: AdminUsersPage,
});

function AdminUsersPage() {
  usePageTitle("Admin - Users");
  return <UsersTable />;
}
